import { WOMEN, MEN } from '../../config/constants-sizes'; // Map old values to new ones.

export var GENDER_MAP = {
  women: WOMEN,
  men: MEN,
  woman: WOMEN,
  man: MEN
};
export var GENDER_TAGS = ['woman', 'man'];
export var LENGTH_LABELS = {
  'full length': 'Full Length',
  kneecap: 'Kneecap',
  calf: '3/4',
  '7/8': '7/8'
};
export var MID_PRICE = '50-100';
export var HIGH_PRICE = '100';
export var LENGTH_TAGS = ['kneecap', '3/4', '7/8', 'full length'];
export var LOW_PRICE = '50';
export var PLP_IMAGE_SIZES = [130, 250, 456];
export var SUPPORT_LABELS = {
  low: 'Light Support',
  medium: 'Medium Support',
  high: 'High Support'
};
export var SUPPORT_TAGS = ['low support', 'medium support', 'high support'];